import { type ComponentType, type ReactElement, type ReactNode } from 'react';
import { Label } from '@/Components/ui/label';
import { FieldError } from './FieldError';
import { LabelContent } from './LabelContent';

interface LabelFieldProps {
    label: string;
    htmlFor?: string;
    labelExtra?: ReactNode;
    icon?: ComponentType<{ className?: string }>;
    description?: string;
    children?: ReactNode;
    value?: ReactNode;
    error?: string;
    className?: string;
}

export function LabelField({ label, htmlFor, labelExtra, icon: Icon, description, children, value, error, className }: LabelFieldProps): ReactElement {
    return (
        <div className={className}>
            {label && (labelExtra ? (
                <div className="flex items-center justify-between text-xs font-normal">
                    <Label htmlFor={htmlFor} className="flex items-center gap-1.5 text-muted-foreground text-xs font-normal">
                        <LabelContent icon={Icon} label={label} description={description} />
                    </Label>
                    {labelExtra}
                </div>
            ) : (
                <Label htmlFor={htmlFor} className="flex items-center gap-1.5 text-muted-foreground text-xs font-normal">
                    <LabelContent icon={Icon} label={label} description={description} />
                </Label>
            ))}
            {children ?? (
                <p className="text-sm font-medium text-foreground">{value}</p>
            )}
            {error && <FieldError message={error} />}
        </div>
    );
}
